var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{attrs:{"prepend":_vm.icon ? '$' : ''}},[_c('b-form-input',{attrs:{"name":_vm.name,"type":"text","value":_vm.formattedValue,"placeholder":_vm.placeholder,"state":_vm.state},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"change":_vm.onChange}}),_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }